import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';
import { TeamsService } from '../teams/teams.service';

@Injectable({
  providedIn: 'root'
})
export class FeeService {

  constructor(private restangular: ApiClient,
              private teamsService: TeamsService) { }

  getFee(teamId: string): Promise<any> {
    return this.restangular.one('fees').one('team', teamId).get().toPromise();
  }

  async getPaymentMethodFee(team: any): Promise<number> {
    const defaultPaymentMethod = await this.teamsService.getPaymentMethod(team);

    const paymentMethods = await this.teamsService.getPaymentMethods(team.id);
    const defaultPaymentMethodId = typeof defaultPaymentMethod === 'string'
      ? defaultPaymentMethod
      : (defaultPaymentMethod as any)?.stripePaymentMethod;
    const paymentMethod = paymentMethods.find(
      (method: any) => method?.stripePaymentMethod === defaultPaymentMethodId,
    );
    if (!paymentMethod?.bankInfo?.type) {
      throw new Error('Default funding method is no longer available. Please choose a valid funding method in Billing.');
    }

    const fee = await this.getFee(team.id);
    return fee[paymentMethod.bankInfo.type === 'us_bank_account' ? 'ach' : 'creditCard'].fee / 100;
  }

}
